import type {
  ShopperAiTagGroupId,
  ShopperAiTagId,
} from "@redotech/effect-api-shared/ids/definitions";
import type {
  TagGroupResponse,
  TagResponse,
} from "@redotech/effect-api-shared/rpc/tag";

export function getMissingRequiredTagGroups(
  ticketTagIds: readonly ShopperAiTagId[],
  allTags: readonly TagResponse[],
  tagGroups: readonly TagGroupResponse[],
): TagGroupResponse[] {
  const requiredGroups = tagGroups.filter((g) => g.requiredTagBeforeClose);
  if (requiredGroups.length === 0) {
    return [];
  }

  const coveredGroupIds = new Set<ShopperAiTagGroupId>(
    ticketTagIds
      .map((tagId) => allTags.find((t) => t.id === tagId)?.tagGroupId)
      .filter((id): id is ShopperAiTagGroupId => id !== undefined),
  );

  return requiredGroups.filter((g) => !coveredGroupIds.has(g.id));
}
